import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { EditFormContent, NumericInputField, BaasicButton, BaasicFormControls } from 'core/components';
function NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalTemplate({ nikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalStore, t }) {
	const {
		form,
		modalParams,
		refreshInventoryCalculation
	} = nikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalStore;
	return (
		<EditFormContent form={form}>
			<div className="modal__header">
				<h3 className='modal__header__title'>{t('FACILITY_ORDER_NEW_FLOW_INVENTORY.EDIT_EMERGENCY_SUPPLY_DAYS.TITLE')}</h3>
			</div>
			<div className="modal__body u-mar--b--tny">
				<div className="form__group">
					<NumericInputField field={form.$('emergencySupplyDays')} />
				</div>
			</div>
			<div className='u-separator--primary'></div>
			<div className='modal__footer'>
				<BaasicButton
					className='btn btn--med btn--light'
					label={t('EDIT_FORM_LAYOUT.CANCEL')}
					disabled={form.submitting}
					onClick={() => modalParams.close()}
				/>
				<BaasicFormControls
					className='btn btn--med btn--primary'
					form={form}
					onSubmit={form.onSubmit}
					disabled={form.submitting || form.validating}
					label={refreshInventoryCalculation ? "Save and Refresh Calculation" : t('EDIT_FORM_LAYOUT.SAVE')}
				/>
			</div>
		</EditFormContent>
	)
}

NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalTemplate.propTypes = {
	nikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalStore: PropTypes.object,
	t: PropTypes.func
};

export default defaultTemplate(NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalTemplate);
